const KEY = "albero_quotes_v1";
const LOGO_KEY = "albero_logo_v1";

export const loadQuotes = () => {
  try {
    return JSON.parse(localStorage.getItem(KEY) || "[]");
  } catch {
    return [];
  }
};

export const saveQuotes = (quotes) => {
  localStorage.setItem(KEY, JSON.stringify(quotes));
};

export const upsertQuote = (quote) => {
  const quotes = loadQuotes();
  const idx = quotes.findIndex((q) => q.id === quote.id);
  const now = new Date().toISOString();
  const record = { ...quote, updatedAt: now };
  if (idx >= 0) quotes[idx] = record;
  else quotes.push({ ...record, createdAt: now });
  saveQuotes(quotes);
  return record;
};

export const deleteQuote = (id) => {
  saveQuotes(loadQuotes().filter((q) => q.id !== id));
};

export const nextQuoteNumber = () => {
  const year = new Date().getFullYear();
  const quotes = loadQuotes();
  const thisYear = quotes.filter((q) =>
    (q.number || "").startsWith(`${year}-`),
  );
  const max = thisYear.reduce((m, q) => {
    const n = parseInt((q.number || "").split("-")[1], 10);
    return Number.isFinite(n) && n > m ? n : m;
  }, 0);
  return `${year}-${String(max + 1).padStart(3, "0")}`;
};

export const loadLogo = () => localStorage.getItem(LOGO_KEY) || "";
export const saveLogo = (dataUrl) => localStorage.setItem(LOGO_KEY, dataUrl);
export const clearLogo = () => localStorage.removeItem(LOGO_KEY);

const CLIENTS_KEY = "albero_clients_v1";

export const loadClients = () => {
  try {
    return JSON.parse(localStorage.getItem(CLIENTS_KEY) || "[]");
  } catch {
    return [];
  }
};

export const saveClientsLocal = (clients) => {
  localStorage.setItem(CLIENTS_KEY, JSON.stringify(clients));
};

export const upsertClient = (client) => {
  if (!client || !client.name) return loadClients();
  const clients = loadClients();
  const idx = clients.findIndex(
    (c) => c.name.trim().toLowerCase() === client.name.trim().toLowerCase(),
  );
  if (idx >= 0) clients[idx] = client;
  else clients.push(client);
  saveClientsLocal(clients);
  return clients;
};
